// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProtocolData } from './protocol-data';
import {
    ProtocolDataFromJSON,
    ProtocolDataFromJSONTyped,
    ProtocolDataToJSON,
    ProtocolDataToJSONTyped,
} from './protocol-data';

/**
 * 
 * @export
 * @interface StudyProtocol
 */
export interface StudyProtocol {
    /**
     * 
     * @type {string}
     * @memberof StudyProtocol
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof StudyProtocol
     */
    created_by: string;
    /**
     * 
     * @type {ProtocolData}
     * @memberof StudyProtocol
     */
    data?: ProtocolData;
    /**
     * 
     * @type {string}
     * @memberof StudyProtocol
     */
    document_location?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyProtocol
     */
    error?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyProtocol
     */
    extraction_job_id?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyProtocol
     */
    protocol_id: string;
    /**
     * 
     * @type {string}
     * @memberof StudyProtocol
     */
    status: StudyProtocolStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof StudyProtocol
     */
    study_id: string;
    /**
     * 
     * @type {string}
     * @memberof StudyProtocol
     */
    updated_at?: string;
}


/**
 * @export
 */
export const StudyProtocolStatusEnum = {
    NotStarted: 'NOT_STARTED',
    InProgress: 'IN_PROGRESS',
    PendingReview: 'PENDING_REVIEW',
    Approved: 'APPROVED',
    Failed: 'FAILED'
} as const;
export type StudyProtocolStatusEnum = typeof StudyProtocolStatusEnum[keyof typeof StudyProtocolStatusEnum];


/**
 * Check if a given object implements the StudyProtocol interface.
 */
export function instanceOfStudyProtocol(value: object): value is StudyProtocol {
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('created_by' in value) || value['created_by'] === undefined) return false;
    if (!('protocol_id' in value) || value['protocol_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('study_id' in value) || value['study_id'] === undefined) return false;
    return true;
}

export function StudyProtocolFromJSON(json: any): StudyProtocol {
    return StudyProtocolFromJSONTyped(json, false);
}

export function StudyProtocolFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudyProtocol {
    if (json == null) {
        return json;
    }
    return {
        
        'created_at': json['created_at'],
        'created_by': json['created_by'],
        'data': json['data'] == null ? undefined : ProtocolDataFromJSON(json['data']),
        'document_location': json['document_location'] == null ? undefined : json['document_location'],
        'error': json['error'] == null ? undefined : json['error'],
        'extraction_job_id': json['extraction_job_id'] == null ? undefined : json['extraction_job_id'],
        'protocol_id': json['protocol_id'],
        'status': json['status'],
        'study_id': json['study_id'],
        'updated_at': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function StudyProtocolToJSON(json: any): StudyProtocol {
    return StudyProtocolToJSONTyped(json, false);
}

export function StudyProtocolToJSONTyped(value?: StudyProtocol | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created_at': value['created_at'],
        'created_by': value['created_by'],
        'data': ProtocolDataToJSON(value['data']),
        'document_location': value['document_location'],
        'error': value['error'],
        'extraction_job_id': value['extraction_job_id'],
        'protocol_id': value['protocol_id'],
        'status': value['status'],
        'study_id': value['study_id'],
        'updated_at': value['updated_at'],
    };
}
